import angular from 'angular';

import csmUtilKeycodes from '../../util/keycodes/keycodes';

export default angular
  .module('csm.ui.events', [csmUtilKeycodes])

  /*****************************************************************************
   * Directive: csmEnter */
  /**
* @ngdoc    directive
* @restrict A
* @module   csm.ui
* @name     csm.ui.events.directive:csmEnter
* 
* @param  {expression} csmEnter  Expression to evaluate on the enter key press
*
* @description
* Utility attribute directive to evaluate an expression when the enter key is pressed.
*
* @example
  <example module="csmEnterExample">
    <file name="index.html">
      <div ng-controller="testController">
        <input type="text" ng-model="myInput" csm-enter="showAlert()"/>
      </div>
    </file>
    <file name="script.js">
      angular.module('csmEnterExample', [ 'csm.ui.events' ]).
      controller("testController", function ($scope) 
        {
        $scope.showAlert = function()
          {
          window.alert("This is what I entered: "+$scope.myInput);
          };
        });
    </file>
  </example>
*****************************************************************************/
  .directive('csmEnter', function ($timeout, KEYCODES) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.on('keypress', function (event) {
          if ((event.which || event.keyCode) == KEYCODES.ENTER) {
            $timeout(function () {
              scope.$eval(attrs.csmEnter, { $event: event });
              scope.$digest();
            });
          }
        });
      }
    };
  })

  /*****************************************************************************
   * Directive: csmMousepress */
  /**
   * @ngdoc    directive
   * @restrict A
   * @module   csm.ui
   * @name     csm.ui.events.directive:csmMousepress
   *
   * @param  {expression} csmMousepress  Expression to evaluate while a mouse key
   *                                     is being pressed
   *
   * @description
   * Utility directive to execute code when a mouse is pressed over an element.
   * The code will repeatedly execute until the mouse is released or the mouse
   * is no longer over the element. This directive will process only for the
   * primary mouse button.
   *****************************************************************************/
  .directive('csmMousepress', function ($interval, $timeout) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        /** Primary Mouse Button Value. */ var BUTTON_PRIMARY = 0;
        /** Current Interval Promise. */ var mIntervalPromise = null;
        /** Mouse pressed indicator. */ var mMousePressed = false;

        /*-------------------------------------------------------*/
        /* Cancel the current promise and remove event listeners */
        /*-------------------------------------------------------*/
        function clearInterval() {
          $interval.cancel(mIntervalPromise);
          mIntervalPromise = null;
          mMousePressed = false;
          element.off('mouseleave', clearInterval);
          element.off('mouseup', onMouseup);
        }

        /*------------------------------------------------*/
        /* Evaluate the directive expression, passing the */
        /* event as a local parameter for the expression  */
        /*------------------------------------------------*/
        function evaluateExpression(event) {
          if (mMousePressed)
            scope.$eval(attrs.csmMousepress, { $event: event });
        }

        /*---------------------------------------*/
        /* Mouse up handler - Clear the interval */
        /* when the primary button is released   */
        /*---------------------------------------*/
        function onMouseup(event) {
          if (event.button == BUTTON_PRIMARY) clearInterval();
        }

        /*-----------------------------------------*/
        /* Set up listener for the mousedown event */
        /*-----------------------------------------*/
        element.on('mousedown', function (event) {
          var notPrimaryButton = event.button != BUTTON_PRIMARY;

          /*-----------------------------------*/
          /* Clear the current interval if set */
          /*-----------------------------------*/
          if (mIntervalPromise) clearInterval();

          /*---------------------------------------*/
          /* Ignore non-primary mouse button press */
          /*---------------------------------------*/
          if (notPrimaryButton) return;

          mMousePressed = true;

          /*------------------------*/
          /* Evaluate initial press */
          /*------------------------*/
          scope.$apply(function () {
            evaluateExpression(event);
          });

          /*--------------------------------------*/
          /* Set up event listeners for canceling */
          /*--------------------------------------*/
          element.on('mouseleave', clearInterval);
          element.on('mouseup', onMouseup);

          /*-----------------------------------------*/
          /* Wait half a second before starting      */
          /* interval in case the button is released */
          /*-----------------------------------------*/
          $timeout(function () {
            if (!mMousePressed) return;

            mIntervalPromise = $interval(function () {
              evaluateExpression(event);
            }, 50);
          }, 500);
        });
      }
    };
  }).name;
